/**
 * Script that tracks the step of klaviyo forms
 * Adds property "data-step" to the klaviyo root element on stepSubmit
 */
$(() => {
  window.addEventListener("klaviyoForms", function(e) { 
    if (e.detail.type == 'embedOpen') {
      const formSelector = `.klaviyo-form-${e.detail.formId}`;
      $(formSelector).data('step', '1');
      $(formSelector).attr('data-step', '1');
    }

    if (e.detail.type == 'stepSubmit') {
      const formSelector = `.klaviyo-form-${e.detail.formId}`;
      let step = parseInt($(formSelector).data('step'));
      step++;
      $(formSelector).data('step', step);
      // Add micro delay to prevent the weird movement of elements
      setTimeout(() => $(formSelector).attr('data-step', step), 250);
    }
  });
});